import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import semver from 'semver';
import yn from 'yn';
import Logger from '@/lib/logger';

var booleanify = function booleanify(value) {
  return Boolean(yn(value));
};

var parse = function parse(value, extraKey) {
  try {
    return JSON.parse(value);
  } catch (error) {
    throw Logger.error("Error parsing `".concat(extraKey, "`"), _defineProperty({
      error: error
    }, extraKey, value));
  }
};

var serverStorage = {
  getItem: function getItem(key) {
    return key;
  },
  removeItem: function removeItem() {
    return null;
  },
  setItem: function setItem() {
    return null;
  },
  clear: function clear() {
    return null;
  },
  key: function key() {
    return null;
  },
  length: 0
};

var UserAgent = /*#__PURE__*/function () {
  function UserAgent() {
    _classCallCheck(this, UserAgent);

    _defineProperty(this, "storage", true ? localStorage : serverStorage);

    _defineProperty(this, "getRelease", function () {
      var webVersion = process.env.VERSION;

      if (!webVersion) {
        return null;
      }

      return webVersion;
    });

    _defineProperty(this, "missingValue", function (item) {
      return "No ".concat(item, " set for mobile client");
    });
  }

  _createClass(UserAgent, [{
    key: "get",
    value: function get(key) {
      return this.storage.getItem(key);
    }
  }, {
    key: "isMobileApp",
    value: function isMobileApp() {
      return Boolean(this.getEmbeddedType());
    }
  }, {
    key: "isIOS",
    value: function isIOS() {
      return this.getEmbeddedType() === 'ios';
    }
  }, {
    key: "isAndroid",
    value: function isAndroid() {
      return this.getEmbeddedType() === 'android';
    }
  }, {
    key: "getEmbeddedType",
    value: function getEmbeddedType() {
      return this.get('X-Mobile-Embedded');
    }
  }, {
    key: "getPlatformName",
    value: function getPlatformName() {
      var _this$getEmbeddedType;

      return (_this$getEmbeddedType = this.getEmbeddedType()) !== null && _this$getEmbeddedType !== void 0 ? _this$getEmbeddedType : 'web';
    }
  }, {
    key: "getPlatformRelease",
    value: function getPlatformRelease() {
      var _process$env$VERSION;

      var defaultVersion = '0.0.0';

      if (this.isMobileApp()) {
        var _this$get;

        return (_this$get = this.get('X-Mobile-Version')) !== null && _this$get !== void 0 ? _this$get : defaultVersion;
      }

      return (_process$env$VERSION = process.env.VERSION) !== null && _process$env$VERSION !== void 0 ? _process$env$VERSION : defaultVersion;
    }
  }, {
    key: "getFormattedPlatformRelease",
    value: function getFormattedPlatformRelease() {
      var _semver$coerce;

      return (_semver$coerce = semver.coerce(this.getParsedPlatformRelease().join('.'))) === null || _semver$coerce === void 0 ? void 0 : _semver$coerce.version;
    }
  }, {
    key: "getAudioVersion",
    value: function getAudioVersion() {
      var defaultAudioVersion = 'legacy';

      if (this.isMobileApp()) {
        return this.get('X-Mobile-Audio-Version') || defaultAudioVersion;
      }

      return defaultAudioVersion;
    }
  }, {
    key: "getParsedPlatformRelease",
    value: function getParsedPlatformRelease() {
      var _this$getPlatformRele = this.getPlatformRelease().replace('b', '.').replace('-', '.').replace('/', '.').split('.').map(function (v) {
        return parseInt(v, 10);
      }),
          _this$getPlatformRele2 = _slicedToArray(_this$getPlatformRele, 3),
          major = _this$getPlatformRele2[0],
          minor = _this$getPlatformRele2[1],
          patch = _this$getPlatformRele2[2];

      return [major, minor, patch];
    }
  }, {
    key: "isLegacyAuth0Flow",
    value: function isLegacyAuth0Flow() {
      var platformRelease = this.getPlatformRelease();

      if (this.isMobileApp()) {
        var _this$getParsedPlatfo = this.getParsedPlatformRelease(),
            _this$getParsedPlatfo2 = _slicedToArray(_this$getParsedPlatfo, 2),
            major = _this$getParsedPlatfo2[0],
            minor = _this$getParsedPlatfo2[1];

        try {
          if (major >= 4) {
            return false;
          }

          if (major === 3 && minor >= 1) {
            return false;
          }

          return true;
        } catch (_unused) {
          Logger.warning("Invalid version: ".concat(platformRelease));
          return true;
        }
      }

      return false;
    }
  }, {
    key: "isQRScannerAvailable",
    value: function isQRScannerAvailable() {
      if (this.isMobileApp()) {
        var version = this.getFormattedPlatformRelease();

        try {
          if (!version) return false;
          return semver.gte(version, '3.1.1');
        } catch (_unused2) {
          return false;
        }
      }

      return false;
    }
  }, {
    key: "isErrorSampling",
    value: function isErrorSampling() {
      if (this.isMobileApp()) {
        var version = this.getFormattedPlatformRelease();

        try {
          if (!version) return false;
          return semver.gte(version, '3.0.0');
        } catch (_unused3) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "isAudioVersionOneApp",
    value: function isAudioVersionOneApp() {
      var isAudioVersionOneApp = this.getAudioVersion().toUpperCase() === 'ONEAPP';

      if (isAudioVersionOneApp) {
        Logger.warning('`X-Mobile-Audio-Version: oneApp` is deprecated. Please use `X-Mobile-Event-Api-Version: 2.0`');
      }

      return isAudioVersionOneApp;
    }
  }, {
    key: "getEventApiVersion",
    value: function getEventApiVersion() {
      var defaultEventApiVersion = 1;
      var eventApiVersion = Number.parseFloat(this.get('X-Mobile-Event-Api-Version'));

      if (Number.isNaN(eventApiVersion)) {
        return defaultEventApiVersion;
      }

      return eventApiVersion;
    }
  }, {
    key: "getFeatureFlagsData",
    value: function getFeatureFlagsData() {
      var jsonString = this.get('X-Mobile-Feature-Flags-Data');

      if (jsonString) {
        return parse(jsonString, 'X-Mobile-Feature-Flags-Data');
      }

      return null;
    }
  }, {
    key: "getOrganizationData",
    value: function getOrganizationData() {
      var jsonString = this.get('X-Mobile-Organization-Data');

      if (jsonString) {
        return parse(jsonString, 'X-Mobile-Organization-Data');
      }

      return null;
    }
  }, {
    key: "getUserData",
    value: function getUserData() {
      var jsonString = this.get('X-Mobile-User-Data');

      if (jsonString) {
        return parse(jsonString, 'X-Mobile-User-Data');
      }

      return null;
    }
  }, {
    key: "getPermissionData",
    value: function getPermissionData() {
      var jsonString = this.get('X-Mobile-Permissions-Data');

      if (jsonString) {
        return parse(jsonString, 'X-Mobile-Permissions-Data');
      }

      return null;
    }
  }, {
    key: "nativeHeader",
    value: function nativeHeader() {
      return booleanify(this.get('X-Mobile-Native-Header'));
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      var accessToken = this.get('X-Mobile-Access-Token');

      if (!accessToken) {
        throw Logger.error(this.missingValue('X-Mobile-Access-Token'));
      }

      return accessToken;
    }
  }, {
    key: "getMechanism",
    value: function getMechanism() {
      var organizationData = this.getOrganizationData();

      if (!organizationData) {
        throw Logger.error(this.missingValue('X-Mobile-Organization-Data'));
      }

      var mechanism = organizationData.authentication.mechanism;
      return mechanism;
    }
  }, {
    key: "getOrganizationIdentifierName",
    value: function getOrganizationIdentifierName() {
      var organizationIdentifierName = this.get('X-Mobile-Organization');

      if (!organizationIdentifierName) {
        throw Logger.error(this.missingValue('X-Mobile-Organization'));
      }

      return organizationIdentifierName;
    }
  }, {
    key: "getRefreshToken",
    value: function getRefreshToken() {
      var refreshToken = this.get('X-Mobile-Refresh-Token');
      var mechanism = this.getMechanism();
      var isMechanismThirdPartyOauth = mechanism === 'third_party_oauth';

      if (!isMechanismThirdPartyOauth) {
        if (!refreshToken) {
          throw Logger.error(this.missingValue('X-Mobile-Refresh-Token'));
        }
      }

      return refreshToken;
    }
  }, {
    key: "getTokenExpiresOn",
    value: function getTokenExpiresOn() {
      var tokenExpiresOn = this.get('X-Mobile-Token-Expires-On');

      if (this.getEventApiVersion() >= 2.1) {
        if (!tokenExpiresOn) {
          throw Logger.error(this.missingValue('X-Mobile-Token-Expires-On'));
        }
      }

      return tokenExpiresOn;
    }
  }, {
    key: "getReturnUrn",
    value: function getReturnUrn() {
      var returnUrn = this.get('X-Mobile-URN-Scheme');

      if (!returnUrn) {
        throw Logger.error(this.missingValue('X-Mobile-URN-Scheme'));
      }

      return returnUrn;
    }
  }]);

  return UserAgent;
}();

export default new UserAgent();